import React from 'react';
import { howItWorks, translations } from '../data/mock';
import { MessageSquare, Package, Search, FileText } from 'lucide-react';

const stepIcons = [MessageSquare, Package, Search, FileText];

const HowItWorksSection = () => {
  const t = translations.howItWorks;

  return (
    <section id="how-it-works" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">
            {t.label}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
            {t.title}
          </h2>
          <p className="text-lg text-gray-600">
            {t.description}
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gray-200" />
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {howItWorks.map((step, index) => {
              const IconComponent = stepIcons[index];
              return (
                <div key={step.step} className="relative">
                  {/* Step Card */}
                  <div className="bg-white rounded-2xl p-8 h-full shadow-sm hover:shadow-lg transition-shadow duration-300">
                    {/* Step Number & Icon */}
                    <div className="relative mb-6">
                      <div className="w-16 h-16 bg-gray-900 rounded-2xl flex items-center justify-center relative z-10">
                        <IconComponent className="w-8 h-8 text-white" />
                      </div>
                      <div className="absolute -top-2 -right-2 w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
                        <span className="text-sm font-bold text-gray-900">{step.step}</span>
                      </div>
                    </div>

                    {/* Content */}
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {step.description}
                    </p>

                    {/* Free Badge for Step 3 */}
                    {step.step === 3 && (
                      <div className="mt-4 inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 rounded-full px-3 py-1">
                        <span className="text-sm font-medium">{t.costLabel}</span>
                      </div>
                    )}
                  </div>

                  {/* Arrow for desktop */}
                  {index < howItWorks.length - 1 && (
                    <div className="hidden lg:flex absolute top-20 -right-4 z-20 w-8 h-8 bg-white rounded-full items-center justify-center shadow-md">
                      <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
